module.exports = __webpack_public_path__ + "static/img/mobilefull.78dfbad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Telll/mobilefull.png
// module id = GmU8
// module chunks = 0